// extracted by mini-css-extract-plugin
export default {"detailList":"DetailList_detailList__x28VW"};